<app-access-manager [namespace]="pageAccessBit">

  <!-- if there's more than one location, list them here instead -->

  <!-- <div *ngIf="selectedMerchant == undefined" [hidden]="!allowBusinessSelection">
    <div [hidden]="selectedMerchant != undefined && !toggleTableOn">
      <app-filterable-table
        #merchantTable
        [tableView]="merchantTableView"
        [options]="merchantTableOptions"
        (refreshed)="handle_recordSetUpdated($event)"
        (selectedRecord)="handle_selectedMerchant($event)"
      ></app-filterable-table>
    </div>
  </div> -->

  <!-- if there's only one location, show it here -->

  @if (selectedMerchant != undefined) {
    <div>
      <app-merchant-business-view></app-merchant-business-view>
    </div>
  }

</app-access-manager>